import DoNotDisturbRoundedIcon from '@mui/icons-material/DoNotDisturbRounded';
import React from 'react';
import { useTranslation } from '@corti/i18n';
import { Tooltip } from 'lib/cortiUI';
export const SkippedStatusIndicator = () => {
    const { t } = useTranslation('missionControlApp', { keyPrefix: 'callsDataGrid' });
    return (React.createElement(Tooltip, { title: t('skippedScoreTooltip', "AI Assessment is not suitable for this interaction. This might be because there wasn't enough data or the interaction was not a fit for the chosen assessment template. You can still manually assess it or contact support for help.") },
        React.createElement(DoNotDisturbRoundedIcon, { fontSize: "small", color: "action" })));
};
